<mat-sidenav-container class="mainWrapper {{ layoutSettings().activeTheme }}" autosize autoFocus [ngClass]="{
  'sidebarNav-mini': layoutSettings().sidenavCollapsed && !resView,
  'sidebarNav-horizontal': false,
  cardBorder: false,
}" [dir]="'ltr'">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!resView) {
    <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="
      layoutSettings().sidenavOpened && !isOver && !resView
    " (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
      <div class="flex-layout">
        <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
        <ng-scrollbar class="position-relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for(item of allMenuItems(); track item.route || item.displayName || $index) {
              <app-nav-item [item]="item" (notify)="sidenav.toggle()" class="top-parent">
              </app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>
      </div>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  @if (resView) {
    <mat-sidenav #leftsidenav [mode]="'over'" [opened]="layoutSettings().sidenavOpened && !isTablet"
      (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
      <div class="flex-layout">
        <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
        <ng-scrollbar class="position-relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for(item of allMenuItems(); track item.route || item.displayName || $index) {
              <app-nav-item [item]="item" (notify)="sidenav.toggle()">
              </app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>
      </div>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
      (toggleMobileNav)="sidenav.toggle()"></app-header>

    <div class="body-wrapper">
      <main class="pageWrapper" [ngClass]="{
          maxWidth: false
        }">
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- ------------------------------------------------------------------
  Mobile Bottom Toolbar
  ------------------------------------------------------------------ -->
<app-mobile-bottom-toolbar></app-mobile-bottom-toolbar>

<!-- ------------------------------------------------------------------
  Apps Panel Overlay
  ------------------------------------------------------------------ -->
<app-apps-panel (closePanel)="onAppsPanelClose()"></app-apps-panel>

<!-- ------------------------------------------------------------------
  Onboarding Modal Overlay
  ------------------------------------------------------------------ -->
<app-onboarding-modal [isOpen]="layoutStore.isOnboardingModalOpen()" (closeModal)="onOnboardingModalClose()">
</app-onboarding-modal>

<!-- ------------------------------------------------------------------
  Tour Floating Prompt (behind GUIDED_TOUR feature flag)
  ------------------------------------------------------------------ -->
<app-tour-floating-prompt *appFeatureFlag="'GUIDED_TOUR'" [isVisible]="layoutStore.showTourPrompt()"
  (startTour)="onStartTour()" (dismiss)="onTourPromptDismiss()">
</app-tour-floating-prompt>